import SiteFooter from "@/components/SiteFooter";

const DatenschutzPage = () => {
  return (
    <div className="page-shell" data-testid="datenschutz-page">
      <main className="legal-main" data-testid="datenschutz-main-content">
        <h1 className="legal-title" data-testid="datenschutz-title">
          Datenschutzerklärung
        </h1>

        <h2 className="legal-section-title" data-testid="datenschutz-section-1">
          1. Datenschutz auf einen Blick
        </h2>
        <h3 className="legal-section-title" data-testid="datenschutz-section-1-1">
          Allgemeine Hinweise
        </h3>
        <p className="legal-text" data-testid="datenschutz-1-1-p1">
          Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
          personenbezogenen Daten passiert, wenn Sie unsere Website besuchen. Personenbezogene Daten
          sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche
          Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten
          Datenschutzerklärung.
        </p>

        <h3 className="legal-section-title" data-testid="datenschutz-section-1-2">
          Datenerfassung auf unserer Website
        </h3>
        <p className="legal-text" data-testid="datenschutz-1-2-p1">
          <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong>
          <br />
          Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen
          Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
        </p>
        <p className="legal-text" data-testid="datenschutz-1-2-p2">
          <strong>Wie erfassen wir Ihre Daten?</strong>
          <br />
          Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann
          es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
        </p>
        <p className="legal-text" data-testid="datenschutz-1-2-p3">
          Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst.
          Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit
          des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie unsere
          Website betreten.
        </p>
        <p className="legal-text" data-testid="datenschutz-1-2-p4">
          <strong>Wofür nutzen wir Ihre Daten?</strong>
          <br />
          Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu
          gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.
        </p>
        <p className="legal-text" data-testid="datenschutz-1-2-p5">
          <strong>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong>
          <br />
          Sie haben jederzeit das Recht unentgeltlich Auskunft über Herkunft, Empfänger und Zweck
          Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die
          Berichtigung, Sperrung oder Löschung dieser Daten zu verlangen. Hierzu sowie zu weiteren
          Fragen zum Thema Datenschutz können Sie sich jederzeit unter der im Impressum angegebenen
          Adresse an uns wenden. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen
          Aufsichtsbehörde zu.
        </p>
        <p className="legal-text" data-testid="datenschutz-1-2-p6">
          Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung
          Ihrer personenbezogenen Daten zu verlangen. Details hierzu entnehmen Sie der
          Datenschutzerklärung unter „Recht auf Einschränkung der Verarbeitung“.
        </p>
        <p className="legal-text" data-testid="datenschutz-1-2-p7">
          <strong>Analyse-Tools und Tools von Drittanbietern</strong>
          <br />
          Beim Besuch unserer Website kann Ihr Surf-Verhalten statistisch ausgewertet werden. Das
          geschieht vor allem mit Cookies und mit sogenannten Analyseprogrammen. Die Analyse Ihres
          Surf-Verhaltens erfolgt in der Regel anonym; das Surf-Verhalten kann nicht zu Ihnen
          zurückverfolgt werden. Sie können dieser Analyse widersprechen oder sie durch die
          Nichtbenutzung bestimmter Tools verhindern. Detaillierte Informationen dazu finden Sie in
          der folgenden Datenschutzerklärung.
        </p>
        <p className="legal-text" data-testid="datenschutz-1-2-p8">
          Sie können dieser Analyse widersprechen. Über die Widerspruchsmöglichkeiten werden wir Sie
          in dieser Datenschutzerklärung informieren.
        </p>

        <h2 className="legal-section-title" data-testid="datenschutz-section-2">
          2. Allgemeine Hinweise und Pflichtinformationen
        </h2>
        <h3 className="legal-section-title" data-testid="datenschutz-section-2-1">
          Datenschutz
        </h3>
        <p className="legal-text" data-testid="datenschutz-2-1-p1">
          Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir
          behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen
          Datenschutzvorschriften sowie dieser Datenschutzerklärung.
        </p>
        <p className="legal-text" data-testid="datenschutz-2-1-p2">
          Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben.
          Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können.
          Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie
          nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.
        </p>
        <p className="legal-text" data-testid="datenschutz-2-1-p3">
          Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation
          per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem
          Zugriff durch Dritte ist nicht möglich.
        </p>

        <h3 className="legal-section-title" data-testid="datenschutz-section-2-2">
          Hinweis zur verantwortlichen Stelle
        </h3>
        <p className="legal-text" data-testid="datenschutz-2-2-p1">
          Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
          <br />
          <br />
          Gabriele Sauer
          <br />
          Spargasse 8
          <br />
          97688 Bad Kissingen
          <br />
          <br />
          Telefon: 0971 13 19 13 88
          <br />
          E-Mail: g.sauer-art-of-life@hotmail.com
        </p>
        <p className="legal-text" data-testid="datenschutz-2-2-p2">
          Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder
          gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen
          Daten (z.B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
        </p>

        <h3 className="legal-section-title" data-testid="datenschutz-section-2-3">
          Widerruf Ihrer Einwilligung zur Datenverarbeitung
        </h3>
        <p className="legal-text" data-testid="datenschutz-2-3-p1">
          Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich.
          Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine
          formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten
          Datenverarbeitung bleibt vom Widerruf unberührt.
        </p>

        <h3 className="legal-section-title" data-testid="datenschutz-section-2-4">
          Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie gegen Direktwerbung
          (Art. 21 DSGVO)
        </h3>
        <p className="legal-text" data-testid="datenschutz-2-4-p1">
          Wenn die Datenverarbeitung auf Grundlage von Art. 6 Abs. 1 lit. e oder f DSGVO erfolgt,
          haben Sie jederzeit das Recht, aus Gründen, die sich aus Ihrer besonderen Situation
          ergeben, gegen die Verarbeitung Ihrer personenbezogenen Daten Widerspruch einzulegen; dies
          gilt auch für ein auf diese Bestimmungen gestütztes Profiling. Die jeweilige
          Rechtsgrundlage, auf denen eine Verarbeitung beruht, entnehmen Sie dieser
          Datenschutzerklärung. Wenn Sie Widerspruch einlegen, werden wir Ihre betroffenen
          personenbezogenen Daten nicht mehr verarbeiten, es sei denn, wir können zwingende
          schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechte und
          Freiheiten überwiegen oder die Verarbeitung dient der Geltendmachung, Ausübung oder
          Verteidigung von Rechtsansprüchen (Widerspruch nach Art. 21 Abs. 1 DSGVO).
        </p>
        <p className="legal-text" data-testid="datenschutz-2-4-p2">
          Werden Ihre personenbezogenen Daten verarbeitet, um Direktwerbung zu betreiben, so haben
          Sie das Recht, jederzeit Widerspruch gegen die Verarbeitung Sie betreffender
          personenbezogener Daten zum Zwecke derartiger Werbung einzulegen; dies gilt auch für das
          Profiling, soweit es mit solcher Direktwerbung in Verbindung steht. Wenn Sie widersprechen,
          werden Ihre personenbezogenen Daten anschließend nicht mehr zum Zwecke der Direktwerbung
          verwendet (Widerspruch nach Art. 21 Abs. 2 DSGVO).
        </p>

        <h3 className="legal-section-title" data-testid="datenschutz-section-2-5">
          Beschwerderecht bei der zuständigen Aufsichtsbehörde
        </h3>
        <p className="legal-text" data-testid="datenschutz-2-5-p1">
          Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer
          Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres
          Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes zu. Das Beschwerderecht besteht
          unbeschadet anderweitiger verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.
        </p>

        <h3 className="legal-section-title" data-testid="datenschutz-section-2-6">
          Recht auf Datenübertragbarkeit
        </h3>
        <p className="legal-text" data-testid="datenschutz-2-6-p1">
          Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung
          eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen,
          maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die direkte Übertragung der
          Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch
          machbar ist.
        </p>

        <h3 className="legal-section-title" data-testid="datenschutz-section-2-7">
          SSL- bzw. TLS-Verschlüsselung
        </h3>
        <p className="legal-text" data-testid="datenschutz-2-7-p1">
          Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher
          Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber
          senden, eine SSL-bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie
          daran, dass die Adresszeile des Browsers von “http://” auf “https://” wechselt und an dem
          Schloss-Symbol in Ihrer Browserzeile.
        </p>
        <p className="legal-text" data-testid="datenschutz-2-7-p2">
          Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns
          übermitteln, nicht von Dritten mitgelesen werden.
        </p>

        <h3 className="legal-section-title" data-testid="datenschutz-section-2-8">
          Auskunft, Sperrung, Löschung und Berichtigung
        </h3>
        <p className="legal-text" data-testid="datenschutz-2-8-p1">
          Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf
          unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft
          und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung,
          Sperrung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema
          personenbezogene Daten können Sie sich jederzeit unter der im Impressum angegebenen
          Adresse an uns wenden.
        </p>

        <h3 className="legal-section-title" data-testid="datenschutz-section-2-9">
          Recht auf Einschränkung der Verarbeitung
        </h3>
        <p className="legal-text" data-testid="datenschutz-2-9-p1">
          Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu
          verlangen. Hierzu können Sie sich jederzeit unter der im Impressum angegebenen Adresse an
          uns wenden. Das Recht auf Einschränkung der Verarbeitung besteht in folgenden Fällen:
        </p>
        <ul className="legal-list" data-testid="datenschutz-2-9-list">
          <li>
            Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten bestreiten,
            benötigen wir in der Regel Zeit, um dies zu überprüfen. Für die Dauer der Prüfung haben
            Sie das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu
            verlangen.
          </li>
          <li>
            Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig geschah / geschieht,
            können Sie statt der Löschung die Einschränkung der Datenverarbeitung verlangen.
          </li>
          <li>
            Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen, Sie sie jedoch zur Ausübung,
            Verteidigung oder Geltendmachung von Rechtsansprüchen benötigen, haben Sie das Recht,
            statt der Löschung die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu
            verlangen.
          </li>
          <li>
            Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine
            Abwägung zwischen Ihren und unseren Interessen vorgenommen werden. Solange noch nicht
            feststeht, wessen Interessen überwiegen, haben Sie das Recht, die Einschränkung der
            Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
          </li>
          <li>
            Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschränkt haben, dürfen diese
            Daten – von ihrer Speicherung abgesehen – nur mit Ihrer Einwilligung oder zur
            Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen oder zum Schutz der
            Rechte einer anderen natürlichen oder juristischen Person oder aus Gründen eines
            wichtigen öffentlichen Interesses der Europäischen Union oder eines Mitgliedstaats
            verarbeitet werden.
          </li>
        </ul>

        <h2 className="legal-section-title" data-testid="datenschutz-section-3">
          3. Datenerfassung auf unserer Website
        </h2>
        <h3 className="legal-section-title" data-testid="datenschutz-section-3-1">
          Cookies
        </h3>
        <p className="legal-text" data-testid="datenschutz-3-1-p1">
          Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf Ihrem
          Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, unser Angebot
          nutzerfreundlicher, effektiver und sicherer zu machen. Cookies sind kleine Textdateien,
          die auf Ihrem Rechner abgelegt werden und Ihr Browser speichert.
        </p>
        <p className="legal-text" data-testid="datenschutz-3-1-p2">
          Die meisten der von uns verwendeten Cookies sind so genannte “Session-Cookies”. Sie
          werden nach Ende Ihres Besuchs automatisch gelöscht. Andere Cookies bleiben auf Ihrem
          Endgerät gespeichert bis Sie diese löschen. Diese Cookies ermöglichen es uns, Ihren
          Browser beim nächsten Besuch wiederzuerkennen.
        </p>
        <p className="legal-text" data-testid="datenschutz-3-1-p3">
          Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert
          werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle
          oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des
          Browser aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalität dieser
          Website eingeschränkt sein.
        </p>
        <p className="legal-text" data-testid="datenschutz-3-1-p4">
          Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs oder zur
          Bereitstellung bestimmter, von Ihnen erwünschter Funktionen (z.B. Warenkorbfunktion)
          erforderlich sind, werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert. Der
          Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von Cookies zur
          technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Soweit andere
          Cookies (z.B. Cookies zur Analyse Ihres Surfverhaltens) gespeichert werden, werden diese in
          dieser Datenschutzerklärung gesondert behandelt.
        </p>

        <h3 className="legal-section-title" data-testid="datenschutz-section-3-2">
          Server-Log-Dateien
        </h3>
        <p className="legal-text" data-testid="datenschutz-3-2-p1">
          Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten
          Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:
        </p>
        <ul className="legal-list" data-testid="datenschutz-3-2-list-1">
          <li>Browsertyp und Browserversion</li>
          <li>verwendetes Betriebssystem</li>
          <li>Referrer URL</li>
          <li>Hostname des zugreifenden Rechners</li>
          <li>Uhrzeit der Serveranfrage</li>
          <li>IP-Adresse</li>
        </ul>
        <p className="legal-text" data-testid="datenschutz-3-2-p2">
          Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.
        </p>
        <p className="legal-text" data-testid="datenschutz-3-2-p3">
          Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der
          Websitebetreiber hat ein berechtigtes Interesse an der technisch fehlerfreien Darstellung
          und der Optimierung seiner Website – hierzu müssen die Server-Log-Files erfasst werden.
        </p>

        <h3 className="legal-section-title" data-testid="datenschutz-section-3-3">
          Kontaktformular
        </h3>
        <p className="legal-text" data-testid="datenschutz-3-3-p1">
          Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem
          Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung
          der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir
          nicht ohne Ihre Einwilligung weiter.
        </p>
        <p className="legal-text" data-testid="datenschutz-3-3-p2">
          Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt somit
          ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Sie können
          diese Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail
          an uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitungsvorgänge
          bleibt vom Widerruf unberührt.
        </p>
        <p className="legal-text" data-testid="datenschutz-3-3-p3">
          Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns zur
          Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die
          Datenspeicherung entfällt (z.B. nach abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende
          gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben unberührt.
        </p>

        <h2 className="legal-section-title" data-testid="datenschutz-section-4">
          4. Newsletter
        </h2>
        <h3 className="legal-section-title" data-testid="datenschutz-section-4-1">
          Newsletterdaten
        </h3>
        <p className="legal-text" data-testid="datenschutz-4-1-p1">
          Wenn Sie den auf der Website angebotenen Newsletter beziehen möchten, benötigen wir von
          Ihnen eine E-Mail-Adresse sowie Informationen, welche uns die Überprüfung gestatten, dass
          Sie der Inhaber der angegebenen E-Mail-Adresse sind und mit dem Empfang des Newsletters
          einverstanden sind. Weitere Daten werden nicht bzw. nur auf freiwilliger Basis erhoben.
          Diese Daten verwenden wir ausschließlich für den Versand der angeforderten Informationen
          und geben diese nicht an Dritte weiter.
        </p>
        <p className="legal-text" data-testid="datenschutz-4-1-p2">
          Die Verarbeitung der in das Newsletteranmeldeformular eingegebenen Daten erfolgt
          ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Die
          erteilte Einwilligung zur Speicherung der Daten, der E-Mail-Adresse sowie deren Nutzung
          zum Versand des Newsletters können Sie jederzeit widerrufen, etwa über den
          "Austragen"-Link im Newsletter. Die Rechtmäßigkeit der bereits erfolgten
          Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt.
        </p>
        <p className="legal-text" data-testid="datenschutz-4-1-p3">
          Die von Ihnen zum Zwecke des Newsletter-Bezugs bei uns hinterlegten Daten werden von uns
          bis zu Ihrer Austragung aus dem Newsletter gespeichert und nach der Abbestellung des
          Newsletters gelöscht. Daten, die zu anderen Zwecken bei uns gespeichert wurden bleiben
          hiervon unberührt.
        </p>

        <h2 className="legal-section-title" data-testid="datenschutz-section-5">
          5. Plugins und Tools
        </h2>
        <h3 className="legal-section-title" data-testid="datenschutz-section-5-1">
          Google Web Fonts
        </h3>
        <p className="legal-text" data-testid="datenschutz-5-1-p1">
          Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte Web Fonts,
          die von Google bereitgestellt werden. Die Google Fonts sind lokal installiert. Eine
          Verbindung zu Servern von Google findet dabei nicht statt.
        </p>

        <h3 className="legal-section-title" data-testid="datenschutz-section-5-2">
          Google Maps (mit Einwilligung)
        </h3>
        <p className="legal-text" data-testid="datenschutz-5-2-p1">
          Diese Seite nutzt über eine API den Kartendienst Google Maps. Anbieterin ist die Google
          Inc., 1600 Amphitheatre Parkway Mountain View, CA 94043, USA.
        </p>
        <p className="legal-text" data-testid="datenschutz-5-2-p2">
          Um den Datenschutz auf unserer Website zu gewährleisten, ist Google Maps deaktiviert, wenn
          Sie unsere Websiite das erste Mal betreten. Eine direkte Verbindung zu den Servern von
          Google wird erst hergestellt, wenn Sie Google Maps selbstständig aktivieren (Einwilligung
          nach Art. 6 Abs. 1 lit. a DSGVO). Auf diese Weise wird verhindert, dass Ihre Daten schon
          beim ersten Betreten der Seite an Google übertragen werden.
        </p>
        <p className="legal-text" data-testid="datenschutz-5-2-p3">
          Nach der Aktivierung wird Google Maps Ihre IP-Adresse speichern. Diese wird anschließend in
          der Regel an einen Server von Google in den USA übertragen und dort gespeichert. Der
          Anbieter dieser Seite hat nach der Aktivierung von Google Maps keinen Einfluss auf diese
          Datenübertragung.
        </p>
        <p className="legal-text" data-testid="datenschutz-5-2-p4">
          Mehr Informationen zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerklärung von
          Google: https://www.google.de/intl/de/policies/privacy/.
        </p>

        <h3 className="legal-section-title" data-testid="datenschutz-section-5-3">
          Google reCAPTCHA
        </h3>
        <p className="legal-text" data-testid="datenschutz-5-3-p1">
          Wir nutzen “Google reCAPTCHA” (im Folgenden “reCAPTCHA”) auf unseren Websites. Anbieter
          ist die Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA (“Google”).
        </p>
        <p className="legal-text" data-testid="datenschutz-5-3-p2">
          Mit reCAPTCHA soll überprüft werden, ob die Dateneingabe auf unseren Websites (z.B. in
          einem Kontaktformular) durch einen Menschen oder durch ein automatisiertes Programm erfolgt.
          Hierzu analysiert reCAPTCHA das Verhalten des Websitebesuchers anhand verschiedener
          Merkmale. Diese Analyse beginnt automatisch, sobald der Websitebesucher die Website
          betritt. Zur Analyse wertet reCAPTCHA verschiedene Informationen aus (z.B. IP-Adresse,
          Verweildauer des Websitebesuchers auf der Website oder vom Nutzer getätigte
          Mausbewegungen). Die bei der Analyse erfassten Daten werden an Google weitergeleitet.
        </p>
        <p className="legal-text" data-testid="datenschutz-5-3-p3">
          Die reCAPTCHA-Analysen laufen vollständig im Hintergrund. Websitebesucher werden nicht
          darauf hingewiesen, dass eine Analyse stattfindet.
        </p>
        <p className="legal-text" data-testid="datenschutz-5-3-p4">
          Die Datenverarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der
          Websitebetreiber hat ein berechtigtes Interesse daran, seine Webangebote vor
          missbräuchlicher automatisierter Ausspähung und vor SPAM zu schützen.
        </p>
        <p className="legal-text" data-testid="datenschutz-5-3-p5">
          Weitere Informationen zu Google reCAPTCHA sowie die Datenschutzerklärung von Google
          entnehmen Sie folgenden Links: https://policies.google.com/privacy?hl=de und
          https://www.google.com/recaptcha/intro/android.html.
        </p>
      </main>

      <SiteFooter />
    </div>
  );
};

export default DatenschutzPage;